export default __webpack_public_path__ + "static/media/bg-s10.406d3ffc.png";